<template>
    <v-container id="account-wishlist-view" :class="$mobile ? 'px-0' : ''">
        <v-row>
            <v-spacer></v-spacer>
            <v-col :cols="$vuetify.breakpoint.mobile ? 12 : 10">
                <v-expansion-panels :class="$vuetify.breakpoint.mobile ? 'mobile' : ''" v-model="expansionPanelIndex" popout>
                    <v-expansion-panel :v-if="auth" v-for="(currentPanelComponent, i) of pageComponents" :key="i">
                        <v-fade-transition leave-absolute>
                            <v-expansion-panel-header>
                                <template v-slot:default="{}">
                                    <v-row class="d-flex align-end mb-4" no-gutters>
                                        <v-col style="min-width: 100px" v-if="!$mobile" class="d-flex align-center mr-8 shrink">
                                            <icon-base height="50" width="25" viewBox="0 0 60 80" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                                                <icon-b iconColor="rgb(213, 0, 0, 1)" />
                                            </icon-base>
                                            <span v-if="!$mobile" class="text-h6 font-weight-light mt-4 ml-n1">
                                                {{ currentPanelComponent.name }}
                                            </span>
                                        </v-col>
                                        <v-col class="text--secondary">
                                            <v-col v-if="$mobile" style="min-width: 100px" class="d-flex align-center mr-8 shrink">
                                                <icon-base height="50" width="25" viewBox="0 0 60 80" icon-name="b" preserveAspectRatio="xMaxYMid meet">
                                                    <icon-b iconColor="rgb(213, 0, 0, 1)" />
                                                </icon-base>
                                                <span class="text-h6 font-weight-light mt-4 ml-n1">
                                                    {{ currentPanelComponent.name }}
                                                </span>
                                            </v-col>
                                            <sub class="d-flex mt-1 ml-4 flex-wrap font-italic">
                                                {{ currentPanelComponent.subprompt }}
                                            </sub>
                                        </v-col>
                                    </v-row>
                                </template>
                            </v-expansion-panel-header>
                        </v-fade-transition>
                        <v-expansion-panel-content>
                            <v-container>
                                <v-subheader>
                                    <v-row>
                                        <v-spacer></v-spacer>
                                        <v-col :cols="10">
                                            <bnft-near-wallet-button :contractId="VUE_APP_NEAR_WISHLIST_CONTRACT_ID" class="mr-2"></bnft-near-wallet-button>
                                        </v-col>
                                    </v-row>
                                </v-subheader>
                                <bnft-wishlist-gift-receipt-alert v-model="giftReceiptAlert" @input="giftReceiptAlert = !giftReceiptAlert"></bnft-wishlist-gift-receipt-alert>
                                <v-row v-if="$mobile">
                                    <v-col :class="$mobile ? 'pb-0' : ''">
                                        <bnft-wishlist-menu :value="wishlists" @create="createEventHandler" @change="
                                                (i) => (index = i)
                                            "></bnft-wishlist-menu>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col v-if="!$mobile" :cols="2" id="side">
                                        <bnft-wishlist-list :value="wishlists" @create="createEventHandler" @change="
                                                (i) => (index = i)
                                            "></bnft-wishlist-list>
                                    </v-col>
                                    <v-col :cols="$mobile ? 12 : 10" id="main">
                                        <v-row class="d-flex">
                                            <v-col :cols="12" id="header" :class="$mobile ? 'py-0' : ''">
                                                <bnft-wishlist-navigation @search="$event => search = $event" @edit="editEventHandler" @view="$event => view = $event" @create="createEventHandler" :value="
                                                        wishlists[index]
                                                    " :view="view"></bnft-wishlist-navigation>
                                            </v-col>
                                            <v-col v-if="wishlists.length" :cols="12" id="table" :class="$mobile ? 'px-0' : ''">
                                                <bnft-wishlist-data-table @support="supportEventHandler" :search="search" :value="wishlists[index]" v-if="view !== 'grid'"></bnft-wishlist-data-table>
                                                <bnft-wishlist-data-grid @support="supportEventHandler" :value="wishlists[index]" v-else></bnft-wishlist-data-grid>
                                            </v-col>
                                            <v-subheader v-if="items > 0" inset class="text-caption font-italic text-uppercase">
                                                End of list
                                            </v-subheader>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-col>
            <v-spacer></v-spacer>
        </v-row>
        <v-overlay :value="!wishlists.length">
            <template>
                <v-btn id="create-button" small dark elevation="0" color="red" @click="createEventHandler"><span class="black--text font-weight-medium">Wish List</span></v-btn>
            </template>
        </v-overlay>
        <v-dialog v-model="createDialog" max-width="1200">
            <v-card>
                <v-card-title v-if="edit" class="d-flex justify-center">Editing wishlist <span class="text-subtitle-1 font-weight-medium ml-2">{{ wishlists[index].id }}</span></v-card-title>
                <v-card-title v-else>Create a wishlist</v-card-title>
                <v-card-text>
                    <bnft-wishlist-create-form v-model="createDialog" :wishlist="wishlists[index]" :edit="edit" @created="wishlistCreatedEventHandler" @reset="resetEventHandler" @cancel="createDialog = false"></bnft-wishlist-create-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <bnft-wishlist-support-dialog v-model="supportDialog" @click:outside="supportDialog = false" @cancel="supportDialog = false" :wishlist="wishlist" :supportItem="supportItem"></bnft-wishlist-support-dialog>
    </v-container>
</template>
<style scoped></style>
<script>
import IconB from './IconB.vue';
import IconBase from './IconBase.vue';
import BnftWishlistDataTable from './BnftWishlistDataTable.vue';
import BnftWishlistDataGrid from './BnftWishlistDataGrid.vue';
import BnftWishlistNavigation from './BnftWishlistNavigation.vue';
import BnftWishlistList from './BnftWishlistList.vue';
import BnftWishlistMenu from './BnftWishlistMenu.vue';
import BnftNearWalletButton from './BnftNearWalletButton.vue';
import BnftWishlistCreateForm from './BnftWishlistCreateForm.vue';
import BnftWishlistSupportDialog from './BnftWishlistSupportDialog.vue';
import BnftWishlistGiftReceiptAlert from './BnftWishlistGiftReceiptAlert.vue';

const { NODE_ENV, VUE_APP_NEAR_WISHLIST_CONTRACT_ID } = process.env;

export default {
    name: 'BnftAccountWishList',
    components: {
        IconBase,
        IconB,
        BnftWishlistDataTable,
        BnftWishlistDataGrid,
        BnftWishlistNavigation,
        BnftWishlistList,
        BnftWishlistMenu,
        BnftNearWalletButton,
        BnftWishlistCreateForm,
        BnftWishlistSupportDialog,
        BnftWishlistGiftReceiptAlert,
    },
    props: {},
    data: function () {
        return {
            NODE_ENV,
            VUE_APP_NEAR_WISHLIST_CONTRACT_ID,
            pageComponents: [
                {
                    name: 'raWishList™',
                    prompt: 'Bra Wish List',
                    subprompt:
                        'A wish list for all of your bra needs, wants, and desires.',
                },
            ],
            contractArgs: {
                index: 0,
                limit: 25,
            },
            itemsPerPage: 5,
            total: 0,
            wishlists: [],
            itemBalances: [],
            createDialog: false,
            supportDialog: false,
            items: 0,
            edit: false,
            view: 'list',
            search: undefined,
            supportItem: undefined,
            giftReceiptAlert: false,
        };
    },
    watch: {
        index(value) {
            const wishlist = this.wishlists[value];
            this.updateBalances(
                wishlist.items.map((item) =>
                    this.$near.uniqueId(wishlist.id, item.id.gtin)
                ),
                value
            );
            this.items = this.wishlists[value].length;
        },
        itemBalances: {
            deep: true,
            handler(itemBalancesArray) {
                const values = itemBalancesArray[this.index];
                const wishlist = this.wishlists[this.index];
                this.items = wishlist?.items?.length;
                for (const balanceTuple of values) {
                    const { item_id: itemId } = balanceTuple[0];
                    const amount = balanceTuple[1];
                    const index = wishlist.items.findIndex(
                        (item) => item.id.gtin === itemId
                    );
                    if (index !== -1) {
                        this.$set(wishlist.items[index], 'balance', amount);
                    }
                }
            },
        },
    },
    computed: {
        wishlist() {
            return this.wishlists[this.index];
        },
        expansionPanelIndex: {
            get: function () {
                return this.$store.state[
                    'account.wishlist.expansionPanelIndex'
                ];
            },
            set: function (val) {
                this.$store.commit({
                    type: 'set',
                    'account.wishlist.expansionPanelIndex': val,
                });
            },
        },
        auth: function () {
            if (!this.expansionPanelIndex) return false;
            const panel = this.pageComponents[this.expansionPanelIndex];
            if (panel && panel.name.toLowerCase() === 'nfts') {
                return NODE_ENV !== 'production';
            } else {
                return true;
            }
        },
        expandedPanel() {
            return document.location.hostname.match(/branfts/) &&
                !this.$store.state['account.wishlist.expansionPanelIndex']
                ? 0
                : 1;
        },
        defaultAccountId() {
            return this.$near.parseNearAccountId(this.$auth.user.nickname);
        },
        index: {
            get: function () {
                return this.$store.state.account.wishlist.index;
            },
            set: function (value) {
                this.$store.commit('updateWishlistIndex', value);
            },
        },
    },
    mounted() {
        const self = this;
        (async () => {
            try {
                self.giftReceiptAlert = this.$route.query?.transactionHashes
                    ? true
                    : false;
                await self.count();
                self.get();
            } catch (error) {
                console.error(error);
                return error;
            }
        })();
        if (
            this.$route.name.match(/account/) &&
            document.location.hostname.match(/branfts.com/)
        ) {
            this.$set(this, 'expansionPanelIndex', 0);
        }
    },
    methods: {
        wishlistCreatedEventHandler(tempId) {
            const wishlist = {
                id: tempId,
                items: { [tempId]: { ...this.$store.state.wishlistItem } },
                media: [],
            };
            this.$set(this.wishlists, this.wishlists.length - 1, wishlist);
        },
        createEventHandler() {
            // need to do some stuff here before opening dialog.
            this.edit = false;
            this.createDialog = true;
        },
        editEventHandler() {
            this.edit = true;
            this.createDialog = true;
        },
        resetEventHandler() {
            this.createDialog = false;
            this.get();
        },
        // Log the user in
        login() {
            this.$auth.loginWithRedirect();
        },
        // Log the user out
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin,
            });
        },
        async count() {
            const wallet = await this.$near.getWalletConnection();
            if (!wallet.isSignedIn()) return
            const count = await this.$near.wishlist({
                functionName: 'wishlist_ids_per_owner',
                contractArgs: {
                    account_id: wallet.getAccountId() || this.defaultAccountId,
                    ...this.contractArgs,
                },
            });
            this.total = count;
        },
        async updateBalances(ids, index) {
            try {
                this.$near
                    .wishlist({
                        functionName: 'wishlist_item_balances',
                        contractArgs: {
                            ids,
                        },
                    })
                    .then((balances) => {
                        this.$set(this.itemBalances, index, balances);
                    });
            } catch (error) {
                console.log(error.message);
                // fallback to web2
            }
        },
        async get() {
            const self = this;
            this.wishlists = await this.$backend.accountWishlists();
            if (!this.wishlists?.length) return;

            const { wishlists, index } = this;
            const wishlist = wishlists[index];

            const ids = wishlist.items.map((item) =>
                this.$near.uniqueId(wishlist.id, item.id.gtin)
            );
            this.updateBalances(ids, index);
            this.$backend.io.on('wishlist_event', function (event) {
                if (event.method_name === 'give_wishlist_items') {
                    const methodArgs = JSON.parse(
                        Buffer.from(event.args, 'base64')
                    );
                    const ids = methodArgs.unique_item_ids.filter(
                        (unique_item_id) =>
                            unique_item_id.wishlist_id ===
                            self.wishlists[index].id
                    );
                    self.updateBalances(ids, index);
                }
            });
        },
        supportEventHandler(item) {
            this.supportDialog = true;
            this.supportItem = item;
        },
    },
};
</script>
